<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60"><circle cx="30" cy="30" r="30" style="fill:#c4c5c9"/><path d="M21.334 3.334a3.333 3.333 0 1 1 3.334 3.334 3.334 3.334 0 0 1-3.334-3.334zm-10.667 0A3.333 3.333 0 1 1 14 6.667a3.334 3.334 0 0 1-3.333-3.333zM0 3.334a3.333 3.333 0 1 1 3.334 3.333A3.334 3.334 0 0 1 0 3.334z" style="fill:#fff" transform="translate(16 27)" fill="currentColor"/></svg>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ri-free-wait',
});
</script>
